<template>
	
	<div class="default-bg">
		<div class="flex-bar">
			<span class="icon-goback" onClick= "history.back();"></span>
			<div class="flex-title">
				<span class="vt-middle">申请取消订单</span>
			</div>
			<div class="flex-right" @click="submitLoading&&cancelSubmit()">提交</div>
		</div>
		<div class="reason-sec" @click="popupVisible=true">
			<span class="text-grey" >
				{{reasonText ? reasonText[0] : '请选择原因' }}
			</span>
			<span class="icon-arrow-right"></span>
		</div>
		<div class="cancel-tips">
			<p>当前订单取消后将无法恢复</p>
			<p>订单若已付金额，退款将原路返回，请注意返回时间。</p>
		</div>


		<mt-popup
		  	v-model="popupVisible"
		  	position="bottom"
		  	class="reason-picker"
		  	>

		  	<mt-picker 
		  	:slots="slots" 
		  	@change="onValuesChange"
		  	:showToolbar= 'true'
		  	:visibleItemCount = '3'
		  	>
		  		<span @click="popupVisible=false">取消</span>
		  		<span @click="checkReason">确定</span>
		  	</mt-picker>
		</mt-popup>

	</div>

	


</template>


<script>
	import Vue from 'vue';
	import { Toast , Popup , Picker} from '@/js/mint-ui';
	Vue.component(Popup.name, Popup);
	Vue.component(Picker.name, Picker);

	import orderManageApi from '@/api/orderManage/api.order'

	export default {

		data(){
			return {
				submitLoading: true,
				popupVisible: false,
				reasonText: '',
				pickerCheck: '',
				slots: [
			        {
			          flex: 1,
			          values: [],
			          className: 'slot1',
			          textAlign: 'center',
			          showToolbar: true,
			        }
			    ],
			}
		},
		mounted(){
			this.slots[0].values = ['不想买了','商品买错','地址写错']
			this.slots[0].defaultIndex = 1
		},
		methods: {
			onValuesChange(picker,values){
				if(values == '') return false;
				this.pickerCheck = values;
			},
			checkReason(){
				this.reasonText = this.pickerCheck;
				this.popupVisible=false;
			},
			cancelSubmit(){
				let self = this;

				if(!this.reasonText[0]){
					Toast('请选择原因')
					return false;
				}
				this.submitLoading = false;
				let orderId = this.$route.params.orderId;

				let cancelParam = {
					orderCode: '',
					cancelReason: '',
					merchantId: ''


				};
				if(this.$route.query.isMchId){
					cancelParam.merchantId = orderId;
					
				
				}else {
					cancelParam.orderCode = orderId;
				}
				cancelParam.cancelReason =self.reasonText[0]
				
				let promise = new Promise(function(resolve,reject){
					orderManageApi.cancelOrder(cancelParam,function(res){
						resolve();
						self.$router.go(-1);
					},function(err){
						Toast(err.body.meta.msg||'系统错误')
						reject();
					},false)
				})

				promise.then(function(){},function(){}).then(function(){
					self.submitLoading = true
				});
				
			}
		}
	}

</script>


<style lang="scss">
	
	@import '../../assets/css/mixin';

	.flex-bar {
		padding: 0 pxToRem(30px);
		background-color: #fff;
		display: flex;
		justify-content: space-between;
		height: pxToRem(100px);
		line-height: pxToRem(100px);
		border-bottom: 1px solid #eee;
	}

	.flex-title {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50%;
		background-color: rgba(255,255,255,0.90);
	}
	
	.flex-right {
		width: 30px;
		color: #666666;
    text-align: right;
	}

	.reason-sec {
		margin-top: pxToRem(40px);
		padding: pxToRem(46px) pxToRem(50px);
		display: flex;
		justify-content: space-between;
		width: 100%;
		background: #fff;
	}

	.cancel-tips {
		padding: pxToRem(40px) pxToRem(50px);
		p {
			&:not(:first-of-type) {
				margin-top: pxToRem(10px);
				color: #666;
			}
		}
	}

	.reason-picker {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// orderCancel.vue?48ccc5c3